import 'view/style/css/main.css';
import React from 'react';
import classNames from "classnames";

import {
    motion,
    useTransform,
    useScroll
} from "framer-motion";
import { throttle } from "throttle-debounce-ts";
import { useEffect, useRef, useState } from "react";
import { Logo } from "view/images/index";

const useElementViewportPosition = (ref) => {
    const [position, setPosition] = useState([0, 0]);

    useEffect(() => {
        if (!ref || !ref.current) return;

        const pageHeight = document.body.scrollHeight;
        const start = ref.current.offsetTop;
        const end = start + ref.current.offsetHeight;

        setPosition([start / pageHeight, end / pageHeight]);
    }, []);

    return { position };
}

const slideAnimation = {

    variants: {
        full: { opacity: "1" },
        partial: { opacity: "0.2" },
        duration: { duration: "0.10s" },
    },
    initial: "partial",
    whileInView: "full",
    transition: "duration",
    viewport: { amount: 1, once: true }
};

function Section02({ state, inView2, ref2 }) {

    const ref = useRef(null);
    const carouselRef = useRef(null);
    const { position } = useElementViewportPosition(ref);
    const [carouselEndPosition, setCarouselEndPosition] = useState(0);
    const { scrollYProgress, scrollY } = useScroll();
    const x = useTransform(scrollYProgress, position, [0, carouselEndPosition]);

    useEffect(() => {
        if (!carouselRef || !carouselRef.current) return;
        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        const resetCarouselEndPosition = () => {
            if (carouselRef && carouselRef.current) {
                const newPosition =
                    carouselRef.current.clientWidth -
                    window.innerWidth +
                    scrollbarWidth +
                    ref.current.offsetLeft * 1;

                setCarouselEndPosition(-newPosition);
            }
        };

        resetCarouselEndPosition();
        const handleResize = throttle(100, resetCarouselEndPosition);

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize)
        };

    }, []);

    return (
        <React.Fragment>

            <div ref={ref}
                className={classNames("section02", {
                    active: ref == true,
                })}>
                <div className="sticky">
                    <Logo className="topLogo" />
                    <Logo className="bottomLogo" />
                    <div className="wrap">
                        <h1 className='title'>
                            이 홈페이지는 이렇게 만들어 졌어요!
                        </h1>
                    </div>
                    <motion.div className="_scroll-content" ref={carouselRef} style={{ x, paddingLeft: "20%", paddingRight: "20%" }} >
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">약간의 기획</div>
                            <div className="hover">
                                필요한것들을 찾고,<br />
                                문구를 생각하고<br />
                                제작에 들어 갔어요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">freepik</div>
                            <div className="hover">
                                이미지들
                                출처는 freepik 이예요!<br />
                                구름 작가 creativetoons

                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">눈누</div>
                            <div className="hover">
                                웹폰트를 사용할때 사용했어요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">mycolor.space</div>
                            <div className="hover">
                                나를 위한 색상을 찾을때,<br />
                                사용 했어요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">dribbble</div>
                            <div className="hover">
                                레퍼런스 홈페이지를<br />
                                찾을때 사용 했어요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">REACT</div>
                            <div className="hover">
                                이 홈페이지를 제작할때 사용한,<br />
                                라이브러리예요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">VSCODE</div>
                            <div className="hover">
                                이 홈페이지를 제작할때 사용한,<br />
                                툴이예요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">classnames</div>
                            <div className="hover">
                                삼항연산자<br />
                                대신 사용하기 위해 쓴 라이브러리예요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">framer-motion</div>
                            <div className="hover">
                                현재 보고있는 Section02를 위한<br />
                                라이브러리예요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">throttle-debounce-ts</div>
                            <div className="hover">
                                현재 보고있는 Section02를 위한<br />
                                라이브러리예요!
                            </div>
                        </motion.div>
                        <motion.div className="_scroll-item"
                            {...slideAnimation}
                        >
                            <div className="default">NAS 서버</div>
                            <div className="hover">
                                이 포트폴리오를<br />
                                올리기위해 사용했어요!
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </div>

        </React.Fragment>
    )
}
export default Section02;